import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=3d21ba16&scoped=true"
import script from "./Input.vue?vue&type=script&lang=js"
export * from "./Input.vue?vue&type=script&lang=js"
import style0 from "./Input.vue?vue&type=style&index=0&id=3d21ba16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d21ba16",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/Input.vue').default,Loader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/loader/Loader.vue').default})
